// Generated by tools/meshy/character.mjs install — do not hand-edit.
// Content revision of the shipped *_all.glb roster; changes when any model does.
export const CHARACTER_ASSET_REVISION = '91f62b488aed4cc9';
/** Roster ids with a skinned model in public/characters. */
export const SKINNED_CHARACTER_IDS = ['volt', 'monolith', 'hex'];
